<template>
    <div class="overflow">
        <div class="titre">Mots-clefs</div>
        <div id="keyword-wrapper">
            <div class="keyword-drawer" v-for="letter in letters">
                <span class="keyword-letter">{{ letter.letter }}</span>
                <ul class="keyword-list">
                    <li class="keyword-item" v-on:click="toggle_keyword(word.id,word.mot)" v-on:mouseleave="hide_keyword(word.id,word.mot)" v-for="word in letter.words" :id="'keyword-'+word.id">
                        <div class="keyword-blob"><div class="keyword-circle" :data-size="word.fiches.length"></div></div>
                        <div class="keyword-name">{{ word.mot }}</div>
                        <div class="keyword-absolute-wrapper">
                            <div class="keyword-occurrences">
                                <ul class="list-occurrences">
                                    <li v-for="occurrence in word.fiches" v-on:click="$router.push(url_base+'mots_clefs/'+occurrence.slug)"><span>{{ occurrence.titre }}</span></li>
                                </ul>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
import { state } from '../../main.js';
import { url_liste_objets, url_base } from '../../variables.js';

var pointilles = {
    strokeColor: 'black',
    dashArray: [2, 20],
    strokeWidth: 2
}

var plein = {
    strokeColor: 'black',
    dashArray: [],
    strokeWidth: 2
}

export default {
    data() {
        return {
            url_base:url_base,
            fiches: state.fiches,
            mots_clefs: state.mots_clefs,
            mode_click: false,
            mot_actif:""
            // paths: []
            // vue_principale: state.vue_principale,
            // modal_ajout: state.modal_ajout,
            // modal_objet: state.modal_objet
        }
    },

    components: {
        // 'v-mots-clefs': MotsClefs
    },

    computed: {
        fiches_affichees: function() {
            //console.log("ok");
            return this.fiches.filter(function(item) {
                //console.log(item.masquer);
                if (item.masquer != false) {
                    return true;
                } else {
                    return false;
                }
            });
        },
        letters : function(){
            //console.log(this.mots_clefs);
            var arr = {};
            var keywords = this.mots_clefs;
            for(var i = 0; i < keywords.length; ++i){
                this.mots_clefs[i].fiches = [];
                var keyword = keywords[i];

                const removeAccents = str => str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
                var first = removeAccents(keyword.mot.split("")[0]);
                /*var first = keyword.mot.split("")[0];*/
                //fill
                for (var j = 0; j < this.fiches.length; j++) {
                    var fiche = this.fiches[j];
                    var fiche_keywords = fiche.mots_clefs;
                    //console.log(j);
                    for(var k = 0; k < fiche_keywords.length; ++k){
                        var kw = fiche_keywords[k];
                        //console.log("   ",kw);
                        if(kw == keyword.id){
                            this.mots_clefs[i].fiches.push(fiche);
                        }
                    }
                    /*let mots_fiche = this.fiches[i].mots_clefs;
                    for (var k = 0; k < mots_fiche.length; k++) {}*/
                }
                //push into corresponding letters
                if(arr[first]){
                    arr[first].words.push(keyword);
                }else{
                    arr[first] = {
                        letter : first,
                        words : []
                    };
                    arr[first].words.push(keyword);
                }
            }

            return arr;
        }
    },
    
    mounted: function() {
        //console.log("MOUNTED");
        /* hide empty letters */
        var blocks = document.getElementsByClassName("keyword-drawer");
        for(var k = 0; k < blocks.length; ++k){
            var children = blocks[k].getElementsByClassName("keyword-item");
            var len = children.length;
            if(len < 1){
                blocks[k].style.display = "none";
            }else{
                for(var c = 0; c < children.length; ++c){
                    //console.log(children[c]);
                    var length = children[c].getElementsByClassName("list-occurrences")[0].children.length;
                    if(length < 1){
                        children[c].style.display = "none";                
                    }else{
                        var val = length * 2.2;
                        children[c].getElementsByClassName("keyword-circle")[0].style.width = val + "px";
                        children[c].getElementsByClassName("keyword-circle")[0].style.height = val + "px";
                        /*children[c].getElementsByClassName("keyword-occurrences")[0].style.top = children[c].getElementsByClassName("keyword-occurrences")[0].parentElement.offsetTop + "px";*/
                    }
                }
            }
        }


        /*paper.install(document);
        paper.setup('liens');
        // paper.view.pixelRatio = 1;
        paper.courbes = [];
        this.creer_liens();*/
    },
    created : function(){
        //console.log("CREATED");
    },
    methods: {
        toggle_keyword(id,mot){
            //console.log(id,mot);
            var nid = "keyword-"+id;
            var el = document.getElementById(nid);
            if(el.classList.contains("keyword-active")){}else{
                document.getElementById(nid).classList.add("keyword-active");
            }
        },
        hide_keyword(id,mot){
            var nid = "keyword-"+id;
            var el = document.getElementById(nid);
            el.classList.remove("keyword-active");
        },
        /*over_fiche(id, mots_clefs) {
            if (this.mode_click == false) {
                // AFFICHER LES COURBES
                if (mots_clefs.length > 0) {
                    for (var i = 0; i < paper.courbes.length; i++) {
                        var path = paper.courbes[i];
                        if (path.data.lieu == id) {
                            path.visible = true;
                            path.style.dashArray = [];
                        } else {
                            path.visible = false;
                        }
                    }
        
                    // AFFICHER LES MOTS CLEFS ACTIFS
                    for (var i = 0; i < mots_clefs.length; i++) {
                        let mot_clef = mots_clefs[i]
                        for (var j = 0; j < this.mots_clefs.length; j++) {
                            if (this.mots_clefs[j].id == mot_clef) {
                                this.mots_clefs[j].survol_actif = true;
                            } 
                        }
                    }
                }
    
                // AFFICHER LA FICHE ACTIVE
                for (var i = 0; i < this.fiches.length; i++) {
                    let fiche = this.fiches[i];
    
                    if (fiche.id == id) {
                        fiche.survol_actif = true;
                        break;
                    }
                }
            }
        },

        over_mot(id) {
            if (this.mode_click == false) {
                for (var i = 0; i < paper.courbes.length; i++) {
                    var path = paper.courbes[i];
                    if (path.data.mot == id) {
                        path.visible = true;
                        path.style.dashArray = [];
                    } else {
                        path.visible = false;
                    }
                }
    
                // AFFICHER FICHES ACTIVES
                for (var i = 0; i < this.fiches.length; i++) {
                    let mots_fiche = this.fiches[i].mots_clefs;
                    for (var j = 0; j < mots_fiche.length; j++) {
                        let mot_fiche = mots_fiche[j];
                        if (mot_fiche == id) {
                            this.fiches[i].survol_actif = true;
                            break;
                        }
                    }
                    
                }
    
    
                // AFFICHER LE MOT ACTIF
                for (var i = 0; i < this.mots_clefs.length; i++) {
                    let mot_clef = this.mots_clefs[i];
    
                    if (mot_clef.id == id) {
                        mot_clef.survol_actif = true;
                        break;
                    }
                }
            }
        },

        out() {
            if (this.mode_click == false) {
                for (var i = 0; i < this.fiches.length; i++) {
                    this.fiches[i].survol_actif = false;
                }
                for (var i = 0; i < this.mots_clefs.length; i++) {
                    this.mots_clefs[i].survol_actif = false;
                }
                this.creer_liens();
            }
        },

        click_mot(id) {

            if (this.mode_click == false) {
                // AFFICHER LE MOT ACTIF
                $('.lieu').hide();
                this.mot_actif = id;
    
                for (var i = 0; i < this.fiches.length; i++) {
                    let mots_fiche = this.fiches[i].mots_clefs;
                    
                    //this.fiches[i].masquer = true;
                    for (var j = 0; j < mots_fiche.length; j++) {
                        let mot_fiche = mots_fiche[j];
                        if (mot_fiche == id) {
                            //this.fiches[i].masquer = false;
                            //console.log(this.fiches[i].id);
                            $('.lieu[data-id="'+this.fiches[i].id+'"]').show();
    
                            break;
                        }
                    }
                }
    
                this.creer_liens();
                for (var i = 0; i < paper.courbes.length; i++) {
                        var path = paper.courbes[i];
                        if (path.data.mot == id) {
                            path.visible = true;
                            path.style.dashArray = [];
                        } else {
                            path.visible = false;
                        }
                    }
                this.mode_click = true;
            } else {
                $('.lieu').show();
                this.mode_click = false;
                this.creer_liens();
            }

            
        },

        creer_liens() {
            paper.project.activeLayer.removeChildren();
            paper.courbes = [];
            let mode_click = this.mode_click;
            let mot_actif = this.mot_actif;
            //mode_click = mode_click;
            //console.log(mode_click + "okok");


            $(".lieu").each(function(index) {

                if ($(this).is(":visible")) {

                    var x1;
                    if ($(this).children("span").width() > $(this).width()) {
                        x1 = $(this).offset().left + $(this).width() + 7;
                    } else {
                        x1 = $(this).children("span").offset().left + $(this).children("span").width() + 5;
                    }
    
                    let y1 = $(this).offset().top + $(this).height() / 2;
    
                    for (var i = 0; i < state.fiches[index]["mots_clefs"].length; i++) {
                        let id_cible = state.fiches[index]["mots_clefs"][i];
                        if (mode_click == true) {
                            if (id_cible != parseInt(mot_actif)) {
                                continue;
                            }
                        }

                        let id_source = state.fiches[index].id;
                        let cible = $(".mot[data-id='" + id_cible + "']").children("span");
                        let x2 = cible.offset().left - 3;
                        let y2 = cible.offset().top + cible.height() / 2 + 10;
    
                        let mx1 = (x2 - x1) / 2 + x1;
                        let my1 = y1;
                        let mx2 = (x2 - x1) / 2 + x1;
                        let my2 = y2;
    
                        var debut = new paper.Point(x1, y1);
                        var poignee1 = new paper.Point(mx1, my1);
                        var poignee2 = new paper.Point(mx2, my2);
                        var fin = new paper.Point(x2, y2);
    
                        var path = new paper.Path();

                        //console.log(mode_click);
                        if (mode_click == true) {
                            path.style = plein;
                        } else {
                            path.style = pointilles;
                        }
                       
                        path.moveTo(debut);
                        path.cubicCurveTo(poignee1, poignee2, fin);
                        path.data.mot = id_cible;
                        path.data.lieu = id_source;
                        paper.courbes.push(path);
                    }
                }
            });
        },
        desactiver_mots() {
            if (this.mode_click == true) {
                $('.lieu').show();
                this.mode_click = false;
                this.creer_liens();
            }
        }*/
    }
};
</script>
<style>

/* original */
* {
    --fond-mots-clefs: rgb(255, 255, 91);
}

#mots_clefs {
    background-color: var(--fond-mots-clefs);
   /* overflow: hidden;*/
}
#mots_clefs:not(.replie) .titre{
   /* background-color: red;*/
    position: sticky;
    top: 5px;
    padding-left: 9px;
}
/*

.volet.replie:not(.home) > div > .titre {
  -webkit-transform: rotate(-90deg);
  transform: rotate(-90deg);
  width: 250px;
  left: -244px;
  top: 8px;
  text-align: right;
  -webkit-transform-origin: top right;
  transform-origin: top right;
  line-height: 26px;
}
*/

.container_mots,
.container_lieux {
    position: absolute;
    height: 100vh;
    top: 0px;
    overflow: auto;
    /*border:1px solid red;*/
    width: 40vw;
    text-align: center;
    -ms-overflow-style: none;  /* IE and Edge */
    scrollbar-width: none;  /* Firefox */
}

.container_mots::-webkit-scrollbar,
.container_lieux::-webkit-scrollbar {
  display: none;
}
.container_mots {
    left: 60vw;
}
.container_lieux {
    left: 0px;
}
.mots,
.lieux {
    position: absolute;
    top: 100px;
    width: 100%;
    text-align: center;
    padding-bottom: 200px;
}
.lieu,
.mot {
    margin: 0;
    margin-left: auto;
    margin-right: auto;
    text-transform: uppercase;
    font-size: 14px;
    background-color: transparent;
    cursor: pointer;
    /*max-width: 400px;
    text-overflow: ellipsis;
    overflow: hidden;*/
    display: block;
    height: 25px;
}
.lieu>span,
.mot>span {
    vertical-align: bottom;
    padding-top: 13px;
    padding-bottom: 10px;
    padding-left: var(--tbm);
    padding-right: var(--tbm);
    line-height: 32px;
    /*height:30px;*/
    /*height:24px;*/
    /*display:inline-block;*/

    /*border:1px solid red;*/
}
.actif {
    background-color: black;
    color: var(--fond-mots-clefs);
}
canvas {
    position: absolute;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    pointer-events: none;
}

/* updates */
#mots_clefs {
    background-color: var(--couleur-mots-clefs);
   /* overflow: hidden;*/
    overflow-y: scroll;
}
#mots_clefs > .overflow{
    height: auto;
    display: block;
}
#keyword-wrapper{
   /* box-shadow: 0 0 0 1px black;
    background-color: lightpink;*/
    padding: 39px;
    padding-bottom: 15vh;
    padding-top: calc(39px * 2);
    min-height: 100px;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-gap: calc(39px / 1);
    /*height: calc(100vh - 39px);*/
}
/* media queries possible to change grid-template-columns HERE */
.keyword-drawer{
    /*box-shadow: 0 0 0 1px black;*/
}
.keyword-letter{
    /*background-color: lightgreen;*/
    display: table;
    width: 100%;
    padding-bottom: 5px;
    padding-left: calc(39px / 3);
    margin-bottom: calc(39px / 3);
    border-bottom: 2px dotted black;
    text-transform: uppercase;
}
.keyword-item ul, .keyword-item li{
    list-style: none;
}
.keyword-item{
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: flex-start;
    cursor: pointer;
}
.keyword-blob{
    position: relative;
    min-width: 39px; min-height: var(--interlignage-courant);
    background-color: transparent;
    display: flex;
    justify-content: center;
    align-items: center;
}
.keyword-circle{
    position: absolute;
    min-width: 1px; min-height: 1px;
    background-color: transparent;
    border-radius: 100%;
    z-index: 10;
    background-color: transparent;
}
.keyword-item:hover .keyword-circle{
    background-color: black;
    min-width: 39px; min-height: 39px;
    z-index: 11;
}
.keyword-item:hover [data-size]{
    color: var(--fond-mots-clefs);
}
.keyword-name{
    margin-left: calc(39px / 6);
    font-size: calc(var(--corps-courant)*1.15);
    line-height: calc(var(--interlignage-courant)*1.15);
}
.keyword-list{
    overflow: hidden;
}
.keyword-absolute-wrapper{
    position: absolute;
}
.keyword-occurrences{
    background-color: transparent;
    padding-left: 39px;
    display: none;
    pointer-events: none;
    z-index: 12;
}
.keyword-occurrences ul{
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    transform: translateY(-4px);
    pointer-events: none;
}
.keyword-occurrences li{
    background-color: white;
    width: auto;
    max-width: 60vw;
    margin-left: calc(39px / 6);
    pointer-events: all;
    padding: 4px 4px;
    box-shadow: 0 0 0 1px black;
    margin-bottom: 1px;
    /*text-transform: uppercase;*/
}
.keyword-occurrences li > span:after{
    content: " ";
    background-color: transparent;
    width: 100%;
    height: 1px;
    display: table;
    transform: translateY(5px);
}
.keyword-occurrences li:hover{
    background-color: black;
    color: white;
}
.keyword-item.keyword-active .keyword-occurrences{
    display: block;
}

[data-size]{
    display: flex;
    justify-content: center;
    align-items: center;
    color: transparent;
}
[data-size]:before{
    content: attr(data-size);
}
.keyword-searched{
    color: orangered;
}
</style>